<template>
  <div>
    <div class="daigou" ref="obtain">
      <div class="daigou-title">
        <!-- 全选 -->
        <div class="checkall fl">
          <input type="checkbox" v-model="checked" @change="checkedAll" />
          <span>すべてを選択</span>
        </div>
        <!-- title -->
        <div class="fl">商城</div>
        <div class="fl details">商品詳細</div>
        <div class="fl">単価</div>
        <div class="fl num">数量</div>
        <div class="fl">値段</div>
        <div class="fl caozuo">操作</div>
      </div>
      <!-- 店铺 -->
      <div class="table" v-for="(item, index) in lists" :key="index">
        <div class="table-top">
          <input type="checkbox" v-model="item.checked" @change="shopChecked(index, item.checked)"
            style="margin-left: 10px" />
          <!-- <el-checkbox ></el-checkbox> -->
          <span>店铺：{{ item.com }}</span>
          <img src="../../../assets/img/1688.png" v-if="item.goods[0].type == 1688" alt />
          <img src="../../../assets/img/taobao.png" v-else-if="item.goods[0].type == 'taobao'" alt />
          <img src="../../../assets/img/tmall.png" v-else-if="item.goods[0].type == 'tmall'" alt />
        </div>
        <!-- 商品详情 -->
        <ul>
          <li v-for="(item2, index2) in item.goods" :key="index2">
            <div class="checked-box fl">
              <input type="checkbox" v-model="item2.checked" @change="commodityChecked(index, index2, item2.checked)" />
            </div>
            <div class="img-box fl" @click="examine(item2)" v-if="item2.company != 'rakumart'">
              <img :src="item2.pic" alt />
            </div>
            <!-- 备注 -->
            <div class="img-box fl" @click="examine(item2)" v-else>
              <img :src="item2.pic" alt />
            </div>
            <div class="txt-box fl">
              <h3 :title="item2.title">{{ item2.title }}</h3>
              <input type="text" class="input" v-model="item2.beikao" placeholder="備考欄"
                @blur="beikao(item2.beikao, item2.id, item)" />
            </div>
            <!-- 颜色 尺寸 -->
            <div class="colour-box fl">
              <p>カラー：{{ item2.color }}</p>
              <p>サイズ：{{ item2.psize }}</p>
            </div>
            <!-- 单价 -->
            <div class="price-box fl" v-if="item2.company != 'rakumart'">
              <div v-for="(item3, index3) in item2.priceRanges" :key="index3">
                <p>￥{{ item3.price }}</p>
                <span>>={{ item3.begin }}PCS ¥{{ item3.price }}</span>
              </div>
            </div>
            <div class="price-box fl" v-else>
              <p style="margin-top: -30px">￥{{ item2.price }}</p>
            </div>
            <!-- 数量 -->
            <div class="num-box fl" v-if="item2.company == 'rakumart'">
              <el-input-number v-model="item2.num" :min="1" label="描述文字" size="small"
                @change="changeNum(item2.num, item2, index, index2, item2.id)"></el-input-number>
            </div>
            <!-- 数量 -->
            <div class="num-box fl" v-else>
              <el-input-number v-model="item2.num" :min="1" label="描述文字" size="small" @change="
                changeNum(
                  item2.num,
                  item2.priceRanges,
                  index,
                  index2,
                  item2.id
                )
                "></el-input-number>
            </div>
            <!-- 小计 -->
            <div class="subtotal fl">￥{{ item2.priceTotal.toFixed(2) }}</div>
            <div class="caozuo fl">
              <el-button size="mini" @click="delItem(item2.id)">削除</el-button>
            </div>
          </li>
        </ul>
      </div>
      <!-- 结算 -->
      <div class="daigou-title total" :class="{ totalAll: isTotal }">
        <div class="checkall fl">
          <input type="checkbox" v-model="checked" @change="checkedAll" />
          <span>
            すべてを選択
            <strong @click="delAll">選択削除</strong>
          </span>
        </div>
        <p>
          選択中商品
          <em>{{ num }}</em> 点 合計:
          <em>￥{{ total.toFixed(2) }}</em>
        </p>
        <button @click="zhuwen()" :class="{ btn: arr != false }">注文へ</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import {
  getCartList,
  delItem,
  changeNum,
  beikao,
} from "../../../api/API/shoppingCart";
import { filter } from "minimatch";
export default {
  data() {
    return {
      isTotal: false,
      checked: false, // 全选
      input: "", // 备注
      price: "",
      lists: [], // 总数据
      num: 0, // 选中的数量
      total: 0, // 选中的总价
      arr: [], // 选中商品的id
      list: {
        mod: "inc",
        act: "ordersys",
        str: "getCartList",
        token: "",
      },
    };
  },
  created() {
    this.getCartList();
  },
  computed: {
    ...mapState(["cartCount"]),
  },
  mounted() {
    // 滚动条的获取
    window.addEventListener("scroll", this.handleScrollx, true);
  },
  methods: {
    ...mapActions(["getCart"]),
    // 请求数据
    getCartList() {
      this.zong = 0;
      this.lists = [];
      this.list.token = localStorage.getItem("token");
      getCartList(this.list).then((res) => {
        this.lists = res.data;
      });
    },
    // 删除购
    delItem(id) {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "delCart",
        token: "",
        ids: id,
      };
      list.token = localStorage.getItem("token");
      this.$confirm("こちらの商品削除されますか？?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "キャンセル",
        type: "warning",
        center: true,
      })
        .then(() => {
          delItem(list).then((res) => {
            if (res.code != 1) return this.$message.error("削除失敗");
            this.getCartList();
            this.total = 0;
            this.num = 0;
            this.getCart();
            this.$message({
              type: "success",
              message: "削除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "削除キャンセル",
          });
        });
    },
    // 备注修改
    beikao(beizhu, id) {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "editCartRemark",
        token: "",
        id: id,
        beikao: beizhu,
      };
      list.token = localStorage.getItem("token");
      beikao(list).then((res) => {
        if (res.code != 1) return;
        this.$message.success("保存成功");
      });
    },
    // 修改数量
    changeNum(num, item, index, index2, id) {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "upCartNum",
        token: localStorage.getItem("token"),
        id: id,
        num: Math.floor(num),
      };
      changeNum(list).then((res) => {
        if (res.code != 1) return;
        if (item.company == "rakumart") {
          this.lists[index].goods[index2].priceTotal = num * item.price;
          this.commodityTotal();
          return false;
        }
        if (item.length == 1) {
          this.lists[index].goods[index2].priceTotal = num * item[0].price;
        } else if (item.length == 2) {
          if (num < item[1].begin) {
            this.lists[index].goods[index2].priceTotal = num * item[0].price;
          } else if (num >= item[1].begin) {
            this.lists[index].goods[index2].priceTotal = num * item[1].price;
          }
        } else if (item.length == 3) {
          if (num < item[1].begin) {
            this.lists[index].goods[index2].priceTotal = num * item[0].price;
          } else if (num >= item[1].begin && num < item[2].begin) {
            this.lists[index].goods[index2].priceTotal = num * item[1].price;
          } else if (num >= item[2].begin) {
            this.lists[index].goods[index2].priceTotal = num * item[2].price;
          }
        }
        this.commodityTotal();
        console.log(123);
      });
    },
    // 店铺全选
    shopChecked(index, checked) {
      var shop = this.lists[index].goods;
      if (checked == true) {
        for (var i = 0; i < shop.length; i++) {
          shop[i].checked = true;
        }
        this.commodityTotal();
      } else if (checked == false) {
        for (var i = 0; i < shop.length; i++) {
          shop[i].checked = false;
        }
        this.commodityTotal();
      }
      this.isCheckedAll();
    },
    // 商品单选
    commodityChecked(index, index2) {
      var shop = this.lists[index].goods;
      var flag = shop.every((item, index) => item.checked == true);
      if (flag == true) {
        this.lists[index].checked = true;
      } else {
        this.lists[index].checked = false;
      }
      this.commodityTotal();
      this.isCheckedAll();
    },
    // 全选商店
    checkedAll() {
      if (!this.lists.length) return;
      if (this.checked == true) {
        for (let i = 0; i < this.lists.length; i++) {
          this.lists[i].checked = true;
          this.shopChecked(i, this.lists[i].checked);
        }
      } else if (this.checked == false) {
        for (let i = 0; i < this.lists.length; i++) {
          this.lists[i].checked = false;
          this.shopChecked(i, this.lists[i].checked);
        }
      }
      this.isCheckedAll();
    },
    // 是否全选中
    isCheckedAll() {
      var flag = this.lists.every((item, index) => item.checked == true);
      if (flag == true) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    // 选中商品数量总数、总价
    commodityTotal() {
      this.total = 0;
      this.num = 0;
      this.arr = [];
      this.lists.forEach((item, i) => {
        item.goods.forEach((goodsItem, j) => {
          if (goodsItem.checked) {
            this.total += goodsItem.priceTotal;
            this.num += goodsItem.num;
            this.arr.push(goodsItem.id);
          }
        });
      });
      console.log(this.total, this.num, this.arr);
    },
    // 查看商品详情
    examine(item) {
      let id = item.iid;
      let type = item.company == "rakumart" ? 1 : item.type;
      // 自营标识 1
      if (type == 1) {
        let routeUrl = this.$router.resolve({
          path: "/details?id=" + id,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        // 1688
        let routeUrl = this.$router.resolve({
          path:
            "/details1688?iid=" +
            id +
            "&type=" +
            type +
            (item.mi_id ? "&mi_id=" + item.mi_id : ""),
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 批量删除
    delAll() {
      var arr = this.arr.join(",");
      this.delItem(arr);
    },
    zhuwen() {
      if (this.arr == false) {
        this.$message.error("商品を選択してください");
      }  else {
        this.$router.push({
          path: "/zhuwen?cid=" + this.arr,
        });
      }
    },
    handleScrollx() {
      if (this.$refs.obtain.getBoundingClientRect().bottom > 730) {
        this.isTotal = true;
      } else {
        this.isTotal = false;
      }
      //   console.log(
      //     "滚动高度",

      //     this.$refs.obtain.getBoundingClientRect().bottom
      //   );
      //   console.log(this.$refs.obtain.getBoundingClientRect().top);
    },
  },
};
</script>
<style lang='scss' scoped>
.daigou {
  input {
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }

  .daigou-title {
    display: flex;
    height: 40px;
    background: #eee;
    margin: 20px 0;
    line-height: 40px;
    color: #333;
    font-weight: 700;
    font-size: 16px;
    text-align: center;

    div {
      flex: 1;
    }

    // .checkall {
    //   margin: 0 130px 0 30px;
    //   span {
    //     margin-left: 5px;
    //   }
    // }
    .details {
      flex: 2;
    }

    // .num {
    //   margin: 0 150px 0 190px;
    // }
    // .caozuo {
    //   margin-left: 100px;
    // }
  }

  .table {
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 700;
    color: #333;

    .table-top {
      height: 40px;
      background: #eee;
      line-height: 40px;
      border: 1px solid #ccc;

      //   border-bottom: 0;
      .el-checkbox {
        margin-left: 30px;
      }

      span {
        margin: 0 10px;
      }

      img {
        vertical-align: middle;
      }
    }

    ul {
      li {
        height: 180px;
        border: 2px solid #ccc;
        border-top: 0;
        display: flex;

        div {
          flex: 1;
          text-align: center;
        }

        .checked-box {
          //   width: 80px;
          margin: 70px 0px 0 0px;
        }

        .img-box {
          //   border: 1px solid #ccc;
          margin: 40px 0px 0 0;
          cursor: pointer;

          img {
            height: 75px;
            width: 75px;
          }
        }

        .txt-box {
          margin: 18px 0px 0 0;

          h3 {
            height: 70px;
            margin-bottom: 10px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            -webkit-box-orient: vertical;
          }

          .input {
            width: 92%;
          }
        }

        .colour-box {
          margin: 60px 0 0 0;
        }

        .price-box {
          margin-top: 10px;
          //   margin: 20px 0px 0 00px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-flow: column;
          overflow: hidden;
          size: 12px;

          div {
            margin-bottom: 5px;
          }
        }

        .num-box {
          margin: 65px 00px 0 00px;
        }

        .subtotal {
          width: 50px;
          margin: 72px 0px 0 0px;
          color: #f3c622;
        }

        .caozuo {
          margin-top: 70px;
        }
      }
    }
  }

  .total {
    width: 1400px;
    height: 40px;
    border: 1px solid #ccc;
    background: #eee;

    p {
      float: left;
      margin-left: 600px;

      em {
        color: #f3c622;
        margin: 0 10px;
        font-weight: 700;
      }
    }

    button {
      float: right;
      width: 100px;
      height: 42px;

      margin-top: -1px;
      font-weight: 700px;
      font-size: 18px;
      color: #333;
      cursor: pointer;
    }

    .btn {
      background-color: #f3c622;
    }

    strong {
      cursor: pointer;
    }
  }

  .totalAll {
    position: fixed;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0);
    margin-bottom: 0;
    z-index: 1;
  }
}

/deep/ .el-input-number__decrease {
  top: 2px;
}

/deep/ .el-input-number__increase {
  top: 2px;
}
</style>
